export const SIZE_FACET_REGULAR_VARIANT =
  'left_hand_facet_size.size_facet_regular_variant';
export const SIZE_FACET_ONE_SIZE = 'left_hand_facet_size.size_facet_one_size';
export const SIZE_FACET_TITLE = 'left_hand_facet_size.size_facet_title';

